var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 4.5835H2.08333C1.6231 4.5835 1.25 4.95659 1.25 5.41683V8.3335C1.25 8.79373 1.6231 9.16683 2.08333 9.16683H7.91667C8.3769 9.16683 8.75 8.79373 8.75 8.3335V5.41683C8.75 4.95659 8.3769 4.5835 7.91667 4.5835Z",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 4.5835V2.91683C2.91675 2.3643 3.13624 1.83439 3.52694 1.44369C3.91764 1.05299 4.44755 0.833496 5.00008 0.833496C5.55262 0.833496 6.08252 1.05299 6.47322 1.44369C6.86392 1.83439 7.08341 2.3643 7.08341 2.91683V4.5835",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d5780fc2ec6f7d9ca4a7aec27d5be6ce.svg";
export { ForwardRef as ReactComponent };